import { FolderPoundOutlineIcon } from './FolderPoundOutlineIcon';

/**
 * author: Michael Irigoyen
 * id AA3153A7-917B-4D2B-9D8E-297AE296F195
 * name folder-pound-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-pound-outline.svg
 * tags
 * - Files / Folders 
 * - Developer / Languages 
 */
export const FolderHashOutlineIcon = FolderPoundOutlineIcon;
export default FolderHashOutlineIcon